import { render, staticRenderFns } from "./toC.vue?vue&type=template&id=ed866f80&scoped=true"
import script from "./toC.vue?vue&type=script&lang=js"
export * from "./toC.vue?vue&type=script&lang=js"
import style0 from "./toC.vue?vue&type=style&index=0&id=ed866f80&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed866f80",
  null
  
)

export default component.exports